// import React, { useCallback, useState, useMemo, useEffect } from "react";
// import { DynamicField } from "@heartfulnessinstitute/react-hfn-forms/dist/DynamicForm";
// import { useDispatch } from "react-redux";
// import PropTypes from "prop-types";
// import { countries_dict } from "@heartfulnessinstitute/react-hfn-forms/dist/cities";
// import { useFetchSrcmApi } from "gatsby-plugin-hfn-profile/fetch-srcm-api";
// import { resetState } from "gatsby-plugin-hfn-profile/state/action_participants_panel";
// import { navigate } from "gatsby";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCar } from "@fortawesome/free-solid-svg-icons";
// import { age_group } from "gatsby-plugin-hfn-profile/components/ParticipantsPanel";
// import getFormattedDate from "sites-common/utils/FormatDate";
// import { MessageBar } from "office-ui-fabric-react";
// import { validateAbhyasiId } from "@heartfulnessinstitute/react-hfn-forms/dist/validations";
// import getMandatoryEnv from "sites-common/utils/getMandatoryEnv";
// import Layout from "../../layout";
// import Seo from "../../components/seo";
// import { ref, timeOptions } from "../../assets/data/visitorRegistration";
// import Breadcrumb from "../../components/Breadcrumb";
// // import MyPhoneInput from "sites-common/components/ui/PhoneNumberInput";

// const VisitorRegistration = ({ location }) => {
//   const { kanhaStaticConfig } = getMandatoryEnv(["kanhaStaticConfig"]);
//   const personData = {};
//   const [error, setError] = useState("");
//   const [staticData, setStaticData] = useState(null);
//   const [favouritesList, setFavouritesList] = useState([]);
//   const [userData, setUserData] = useState({
//     plan_a_stay: false,
//     arrival_date: "",
//     arrival_time: "",
//     departure_date: "",
//     departure_time: "",
//     trainer_id: "",
//     trainer_name: "",
//     trainer_number: "",
//     emergency_contact_name: "",
//     emergency_contact_number: "",
//   });
//   const params = new URLSearchParams(location.search);
//   const { fetchSrcmApi } = useFetchSrcmApi();
//   const pnr = params.get("pnr");
//   const dispatch = useDispatch();
//   const LOCATION = 1558;
//   const currentDate = new Date();
//   const maxDateAllowed = new Date(currentDate).setMonth(
//     currentDate.getMonth() + 6
//   );

//   const bandaraStartDate = new Date(staticData?.bandara?.startDate).getTime();
//   const bandaraEndDate = new Date(staticData?.bandara?.endDate).getTime();

//   const breadCrumbs = [
//     {
//       id: 1,
//       label: "Home",
//       url: "/",
//     },
//     {
//       id: 2,
//       label: "General Visit",
//       url: `/visitors`,
//     },
//     {
//       id: 3,
//       label: "Arrival/Departure",
//       url: "/visitors/register/",
//     },
//   ];

//   useEffect(() => {
//     const request = new Promise((resolve) => {
//       fetch(kanhaStaticConfig).then((res) => {
//         const result = res.json().then((data) => data);
//         resolve(result);
//       });
//     });

//     request.then((data) => {
//       if (data) {
//         setStaticData(data);
//       }
//     });
//   }, [kanhaStaticConfig]);

//   useEffect(() => {
//     let isMounted = true;
//     fetchSrcmApi({
//       api: `/api/v2/me/userdata/`,
//       client: "eventsClient",
//     })
//       .then((data) => {
//         if (isMounted) {
//           setFavouritesList(data.results);
//         }
//       })
//       .catch(() => {});
//     return () => {
//       isMounted = false;
//     };
//   }, [fetchSrcmApi]);

//   const BandaraDateCheck = useMemo(() => {
//     const Arrival = new Date(userData.arrival_date).getTime();
//     const Departure = new Date(userData.departure_date).getTime();
//     return (
//       (bandaraStartDate > Arrival && bandaraStartDate < Departure) ||
//       (bandaraEndDate > Arrival && bandaraEndDate < Departure)
//     );
//   }, [
//     userData.arrival_date,
//     userData.departure_date,
//     bandaraEndDate,
//     bandaraStartDate,
//   ]);

//   const formValidator = useCallback(
//     (vals) => {
//       const currentDateTime = new Date().getTime();
//       const arrivalDate = new Date(vals?.arrival_date);
//       const departureDate = new Date(vals?.departure_date).getTime();
//       const maxDayAllowed = staticData?.restrictions?.maxContinuousDays || 700;
//       const maxDate = new Date(arrivalDate).setDate(
//         arrivalDate.getDate() + maxDayAllowed
//       );
//       if (
//         !vals.arrival_date ||
//         !vals.arrival_time ||
//         !vals.emergency_contact_name ||
//         !vals.emergency_contact_number
//       ) {
//         return "Please fill all fields.";
//       }
//       if (vals.plan_a_stay) {
//         if (!vals.departure_date || !vals.departure_time) {
//           return "Please fill all fields.";
//         }
//         if (!BandaraDateCheck) {
//           if (!vals.trainer_id || !vals.trainer_name || !vals.trainer_number) {
//             return "Please fill all fields.";
//           }
//           if (
//             "trainer_number" in vals &&
//             !(vals.trainer_number.length > 6 && vals.trainer_number.length < 15)
//           ) {
//             return "Invalid trainer number";
//           }
//           if (!validateAbhyasiId(vals.trainer_id)) {
//             return "Enter a valid Trainer id";
//           }
//           if (!vals.trainer_number.includes("+")) {
//             return "Please enter country code along with Trainer contact number";
//           }
//         }
//       }
//       if ("arrival_date" in vals && currentDateTime > arrivalDate.getTime()) {
//         return "Arrival date should be ahead of current Date";
//       }
//       if ("departure_date" in vals && departureDate < arrivalDate.getTime()) {
//         return "Departure date should be ahead of arrival Date";
//       }

//       if (
//         !(
//           vals.emergency_contact_number.length > 6 &&
//           vals.emergency_contact_number.length < 15
//         )
//       ) {
//         return "Invalid Emergency contact number";
//       }
//       if (!vals.emergency_contact_number.includes("+")) {
//         return "Please enter country code along with emergency contact number";
//       }

//       if ("departure_date" in vals && departureDate > maxDate) {
//         return "You are only allowed to stay for one week.";
//       }
//       return false;
//     },
//     [BandaraDateCheck, staticData?.restrictions?.maxContinuousDays]
//   );

//   const addToFavourites = useCallback(
//     (person) => {
//       let contains = false;
//       if (person) {
//         favouritesList.forEach((item) => {
//           if (item.data.full_name === person.full_name) {
//             contains = true;
//           }
//           return item;
//         });
//       }
//       if (!contains) {
//         fetchSrcmApi({
//           api: `/api/v2/me/userdata/`,
//           method: "POST",
//           methodParams: { data: person },
//           client: "eventsClient",
//         })
//           .then(() => {})
//           .catch(() => {});
//       }
//       return null;
//     },
//     [favouritesList, fetchSrcmApi]
//   );

//   const getStatus = useMemo(() => {
//     const stayStatus =
//       personData?.poi?.poi_type === "srcmid" ? "confirmed" : "approvalpending";
//     return userData.plan_a_stay ? stayStatus : "confirmed";
//   }, [personData?.poi?.poi_type, userData.plan_a_stay]);

//   const onSubmit = useCallback(() => {
//     let isMounted = true;
//     const body = [];
//     if (formValidator(userData)) {
//       setError(formValidator(userData));
//       return null;
//     }
//     setError("");
//     const commonFields = {
//       pnr,
//       ref,
//       visit_json: {
//         plan_a_stay: userData.plan_a_stay,
//         trainer_id: userData.trainer_id ? userData.trainer_id : null,
//         trainer_name: userData.trainer_name ? userData.trainer_name : null,
//         trainer_number: userData.trainer_number
//           ? userData.trainer_number
//           : null,
//         emergency_contact_name: userData.emergency_contact_name
//           ? userData.emergency_contact_name
//           : null,
//         emergency_contact_number: userData.emergency_contact_number
//           ? userData.emergency_contact_number
//           : null,
//       },
//       meditation_center: LOCATION,
//       arrival_date: `${userData.arrival_date}T${userData.arrival_time}Z`,
//       departure_date: userData.plan_a_stay
//         ? `${userData.departure_date}T${userData.departure_time}Z`
//         : `${userData.arrival_date}T${userData.arrival_time}Z`,
//     };
//     personData?.persons?.map((item) => {
//       if (item.favourite) {
//         addToFavourites(item);
//       }
//       return body.push({
//         ...commonFields,
//         name: item?.full_name,
//         email: item?.email,
//         mobile: item?.mobile,
//         country_id: countries_dict[item?.country],
//         status: getStatus,
//         visit_json: {
//           ...commonFields.visit_json,
//           registered_by: item?.poi_type,
//         },
//       });
//     });
//     fetchSrcmApi({
//       api: `/api/v2/ashram-visits/`,
//       client: "eventsClient",
//       method: "POST",
//       methodParams: JSON.stringify(body),
//     })
//       .then(() => {
//         if (isMounted) {
//           navigate(`/pnr?pnr=${pnr}&status=success&type=visitor`);
//           dispatch(resetState());
//         }
//       })
//       .catch(() => {
//         if (isMounted) {
//           navigate(`/pnr?pnr=${pnr}&status=failure&type=visitor`);
//           dispatch(resetState());
//         }
//       });
//     return () => {
//       isMounted = false;
//     };
//   }, [
//     dispatch,
//     fetchSrcmApi,
//     personData?.persons,
//     pnr,
//     LOCATION,
//     userData,
//     addToFavourites,
//     formValidator,
//     getStatus,
//   ]);

//   const discardForm = () => {
//     setUserData({
//       plan_a_stay: false,
//       arrival_date: "",
//       arrival_time: "",
//       departure_date: "",
//       departure_time: "",
//       trainer_id: "",
//       trainer_name: "",
//       trainer_number: 0,
//       emergency_contact_name: "",
//       emergency_contact_number: 0,
//     });
//   };

//   return (
//     <>
//       <Seo title="Kanha santhi vanam | Visitor Registration" />
//       <Layout isSticky wrapperClass="visitor-register">
//         <div className="container">
//           <Breadcrumb items={breadCrumbs} />
//           <div className="visitor_main">
//             <div className="widht-50 bg-greyimg margin10-50 visitor-title">
//               <h2>Step 2</h2>
//               <h4>
//                 <FontAwesomeIcon icon={faCar} size="1x" /> Arrival/Departure
//               </h4>
//               <p>
//                 Registration number
//                 <br />
//                 <small>{pnr}</small>
//               </p>
//               <div className="visitor_form">
//                 {/* <DynamicForm
//                   formFields={registrationOptions.fields}
//                   newFormLayout={fLayout}
//                   formValidator={formValidator}
//                   onSubmit={(e) => onSubmit(e)}
//                 /> */}
//                 <DynamicField
//                   name="plan_a_stay"
//                   onChange={(e) => setUserData({ ...userData, plan_a_stay: e })}
//                   label="Are you Planning to stay "
//                   type="toggle"
//                   value={userData.plan_a_stay}
//                 />
//                 <DynamicField
//                   name="arrival_date"
//                   value={userData.arrival_date}
//                   label="Arrival Date"
//                   type="date"
//                   onChange={(e) =>
//                     setUserData({ ...userData, arrival_date: e })
//                   }
//                   props={{
//                     minDate: getFormattedDate(currentDate),
//                     maxDate: getFormattedDate(maxDateAllowed),
//                   }}
//                 />
//                 <DynamicField
//                   name="arrival_time"
//                   value={userData.arrival_time}
//                   label="Arrival Time"
//                   type="select"
//                   onChange={(e) =>
//                     setUserData({ ...userData, arrival_time: e })
//                   }
//                   options={timeOptions}
//                   props={{
//                     style: {
//                       border: "1px solid #eeeeee",
//                     },
//                   }}
//                 />
//                 {userData.plan_a_stay && (
//                   <div>
//                     <DynamicField
//                       name="departure_date"
//                       value={userData.departure_date}
//                       label="Departure Date"
//                       type="date"
//                       onChange={(e) =>
//                         setUserData({ ...userData, departure_date: e })
//                       }
//                       props={{
//                         minDate: getFormattedDate(currentDate),
//                         maxDate: getFormattedDate(maxDateAllowed),
//                       }}
//                     />
//                     <DynamicField
//                       name="departure_time"
//                       value={userData.departure_time}
//                       label="Departure Time"
//                       type="select"
//                       options={timeOptions}
//                       props={{
//                         style: {
//                           border: "1px solid #eeeeee",
//                         },
//                       }}
//                       onChange={(e) =>
//                         setUserData({ ...userData, departure_time: e })
//                       }
//                     />
//                   </div>
//                 )}
//                 {userData.plan_a_stay && !BandaraDateCheck && (
//                   <div>
//                     <div className="input_field_box">
//                       <span>Trainer ID</span>
//                       <input
//                         className="input_field form-control"
//                         type="text"
//                         name="trainer_id"
//                         // id="trainer_id"
//                         value={userData.trainer_id}
//                         onChange={(e) =>
//                           setUserData({
//                             ...userData,
//                             trainer_id: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                     <div className="input_field_box">
//                       <span>Trainer Name</span>
//                       <input
//                         className="input_field"
//                         type="text"
//                         name="trainer_name"
//                         id="trainer_name"
//                         value={userData.trainer_name}
//                         onChange={(e) =>
//                           setUserData({
//                             ...userData,
//                             trainer_name: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                     <div className="input_field_box ">
//                       <span className="my-1">Trainer Contact Number</span>
//                       {/* <div className="wrap_to_input"> */}
//                       <input
//                         value={userData.trainer_number}
//                         type="phone"
//                         name="trainer_number"
//                         placeholder=""
//                         onChange={(e) =>
//                           setUserData({
//                             ...userData,
//                             trainer_number: e.target.value,
//                           })
//                         }
//                       />
//                       <small>i.e. +918888888888</small>
//                       {/* </div> */}
//                     </div>
//                   </div>
//                 )}
//                 <div className="input_field_box">
//                   <span className="my-1">Emergency Contact Name</span>
//                   <input
//                     className="input_field"
//                     type="text"
//                     name="emergency_contact_name"
//                     id="emergency_contact_name"
//                     value={userData.emergency_contact_name}
//                     onChange={(e) =>
//                       setUserData({
//                         ...userData,
//                         emergency_contact_name: e.target.value,
//                       })
//                     }
//                   />
//                 </div>
//                 <div className="input_field_box">
//                   <span className="my-1">Emergency Contact Number</span>
//                   {/* <div className="wrap_to_input"> */}
//                   <input
//                     className="input_field"
//                     name="emergency_contact_number"
//                     value={userData.emergency_contact_number}
//                     type="phone"
//                     placeholder=""
//                     onChange={(e) =>
//                       setUserData({
//                         ...userData,
//                         emergency_contact_number: e.target.value,
//                       })
//                     }
//                   />
//                   <small>i.e. +918888888888</small>
//                   {/* </div> */}
//                 </div>
//                 {error && <MessageBar className="mt-2">{error}</MessageBar>}
//                 <div className="d-flex justify-content-end mb-3 mt-3 gap-3">
//                   <button
//                     type="button"
//                     className="discard_btn"
//                     onClick={() => discardForm()}
//                   >
//                     Discard
//                   </button>
//                   <button
//                     type="button"
//                     className="register_btn"
//                     onClick={() => onSubmit()}
//                   >
//                     Register
//                   </button>
//                 </div>
//               </div>
//             </div>
//             {!!personData?.persons && personData?.persons[0]?.full_name && (
//               <div className="visitor_participants">
//                 <h3>Participants Details</h3>
//                 <div className="visitor_participants_collection">
//                   {personData?.persons.map((entries) => (
//                     <div
//                       className="visitor_participants_item"
//                       key={entries.full_name}
//                     >
//                       <div>
//                         <h4>{entries.full_name}</h4>
//                       </div>
//                       <div className="visitor_inner_flex">
//                         <span>{entries.center}</span>
//                         <span>{entries.country}</span>
//                         <div className="visitor_badge">{entries.gender}</div>
//                         <div className="visitor_badge">
//                           {age_group(entries.age_group)}
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </Layout>
//     </>
//   );
// };

// VisitorRegistration.defaultProps = {
//   location: { search: "" },
// };

// VisitorRegistration.propTypes = {
//   location: PropTypes.shape({
//     search: PropTypes.string,
//   }),
// };

// export default VisitorRegistration;

export default () => "ok";
